module.exports = __webpack_public_path__ + "static/img/cxc.40aa617.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/cxc.png
// module id = U3Ku
// module chunks = 4